import 'antd/es/message/style/index.css';
import 'antd/es/progress/style/index.css';

import './css/theme/index.css';
import './css/antd-index.css';
import './css/antd-tooltip-modified.css';

// dayjs config
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(relativeTime, {
  thresholds: [
    { l: 's', r: 1 },
    { l: 'm', r: 1 },
    { l: 'mm', r: 59, d: 'minute' },
    { l: 'h', r: 1 },
    { l: 'hh', r: 23, d: 'hour' },
    { l: 'd', r: 1 },
    { l: 'dd', r: 31, d: 'day' },
    { l: 'M', r: 1 },
    { l: 'MM', r: 11, d: 'month' },
    { l: 'y', r: 1 },
    { l: 'yy', d: 'year' },
  ],
});

export { PreviewCardContainer } from './components/RichTextEditor/components/PreviewCardContainer';
export { RichTextEditor, RichTextEditorHandle } from './components/RichTextEditor';
export { RichTextCommentEditor } from './components/RichTextEditor/CommentEditor';
export { ImageUpload as EditorImageUploader } from './components/RichTextEditor/components/ImageUpload';
export { EditorEmojiPicker } from './components/RichTextEditor/components/EditorEmojiPicker';

export { LuckyDraw } from './components/LuckyDraw';
export { Thread } from './components/Thread';
export { InteractEligibilities } from './components/common/EligibilitiesFields/fields';
export { CommentEligibilities, CommentEligibilityModal } from './components/PostFooter';
export { Poll } from './components/Poll';
export { Qa } from './components/Qa';
export { Quest } from './components/Quest';
export * from './components/RichTextEditor/utils';
export { setCommonDependency } from './dependency';
export { SetGroupEligibilityPanel, SetGroupEligibilities } from './components/Group';

export { richEditorI18n } from './utils/i18n';

export { QuestActionList } from './components/Quest/const';

export { TotalFeeCard } from './components/Quest/components/PayInfoCard';
